// Avatar data mapping - edit names here to match photos
import avatar1 from "@/images/avatars/avatar-1.jpg";
import avatar2 from "@/images/avatars/avatar-2.jpg";
import avatar3 from "@/images/avatars/avatar-3.jpg";
import avatar4 from "@/images/avatars/avatar-4.jpg";
import avatar5 from "@/images/avatars/avatar-5.jpg";
import avatar6 from "@/images/avatars/avatar-6.jpg";
import avatar7 from "@/images/avatars/avatar-7.jpg";
import avatar8 from "@/images/avatars/avatar-8.jpg";
import avatar9 from "@/images/avatars/avatar-9.jpg";
import avatar10 from "@/images/avatars/avatar-10.jpg";
import avatar11 from "@/images/avatars/avatar-11.jpg";
import avatar12 from "@/images/avatars/avatar-12.jpg";

export interface AvatarProfile {
  id: number;
  name: string;
  avatarPath: string;
}

export const AVATAR_PROFILES: AvatarProfile[] = [
  { id: 1, name: "Tonya", avatarPath: avatar1 },
  { id: 2, name: "Jose", avatarPath: avatar2 },
  { id: 3, name: "Amir", avatarPath: avatar3 },
  { id: 4, name: "Jordan", avatarPath: avatar4 },
  { id: 5, name: "Lilian", avatarPath: avatar5 },
  { id: 6, name: "Ying Lee", avatarPath: avatar6 },
  { id: 7, name: "Taylor", avatarPath: avatar7 },
  { id: 8, name: "Morgan", avatarPath: avatar8 },
  { id: 9, name: "Riley", avatarPath: avatar9 },
  { id: 10, name: "Jamie", avatarPath: avatar10 },
  { id: 11, name: "Casey", avatarPath: avatar11 },
  { id: 12, name: "Drew", avatarPath: avatar12 },
];

// Helper function to get profile by ID
export const getAvatarProfile = (id: number): AvatarProfile | undefined => {
  return AVATAR_PROFILES.find(profile => profile.id === id);
};
